// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story","5177":"home"}[chunkId] || chunkId) + "-" + {"3093":"df661903501f65d7514c","3180":"bbabee505681bfda3b65","3424":"fed7038978d6da191a04","5177":"3fa8158cdb1250bd857b"}[chunkId] + ".css";
};